import AdventureSingleReview from './AdventureSingleReview'
import styles from './AdventuresReviewsList.module.scss'
import PropTypes from 'prop-types'

export default function AdventureFullReviewsList({ reviews }) {
  return (
    <div className={styles.reviewsList}>
      {reviews.map((review, index) => (
        <AdventureSingleReview key={index} review={review} />
      ))}
    </div>
  )
}

AdventureFullReviewsList.propTypes = {
  reviews: PropTypes.object.isRequired,
}
